import { connect } from 'react-redux';
import { useLocation } from 'react-router';

import { getLocale } from '../../../configuration';
import type { RootState } from '../../../configuration/setup/store';
import { getTenant, type Tenant } from '../common/utils/tenants';
import { redirectIfSkuMatches } from './redirectToOpenMarketplace';

const ProductDetailsRedirectComponent = (props: { locale: string; tenant: Tenant }) => {
    const { pathname } = useLocation();
    const sku = pathname.split('/').pop();

    if (!sku) {
        redirectIfSkuMatches(undefined, props.locale);
        return null;
    }

    const suffixIndex = sku.lastIndexOf('-');
    const hasLegacyVariantSuffix = /-sku\d+-/.test(sku);

    if (hasLegacyVariantSuffix && suffixIndex > 0) {
        redirectIfSkuMatches(sku.substring(0, suffixIndex), props.locale, sku.substring(suffixIndex + 1));
        return null;
    }

    redirectIfSkuMatches(sku, props.locale);
    return null;
};

const mapStateToProps = (state: RootState) => ({
    tenant: getTenant(state),
    locale: getLocale(state),
});

export const ProductDetailsRedirect = connect(mapStateToProps)(ProductDetailsRedirectComponent);
